import { render, staticRenderFns } from "./FilteringSetting.vue?vue&type=template&id=37cc1345&scoped=true&"
import script from "./FilteringSetting.vue?vue&type=script&lang=ts&"
export * from "./FilteringSetting.vue?vue&type=script&lang=ts&"
import style0 from "./FilteringSetting.vue?vue&type=style&index=0&id=37cc1345&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc1345",
  null
  
)

export default component.exports